const domains = {
  production: {
    domain: 'https://hrpay.laway.cn',
    name: '外网正式服'
  },
  dev: {
    domain: 'https://hrpay.laway.cn',
    name: '内网开发服'
  }
}
const isDev = process.env.NODE_ENV !== 'production'
let server = 'production'
if (isDev) {
  server = localStorage.getItem('server')
  if (!server || !domains[server]) {
    server = 'dev'
  }
  localStorage.setItem('server', server)
}
const url = domains[server].domain + '/api/speed-front'
export const BASE_URL = url



// WEBPACK FOOTER //
// ./src/libs/config.js